import { JSONModel } from './jsonModel';
import { createCounter } from '@/store/utils/counter';

const getLocalId = createCounter();
const localIdPrefix = 'local_region_';

export function isRegionLocalId(val: any): val is string {
  if (typeof val === 'string' && val.startsWith(localIdPrefix)) {
    return true;
  }

  return false;
}

export interface RegionJSON {
  id: number;
  code: string;
  name: string;
  status?: 0 | 1;
  admin_email: string[];
}

export default class Region extends JSONModel<RegionJSON> {
  public id: string | number = 0;
  public status: 0 | 1 = 1;
  public code: string = '';
  public name: string = '';
  public adminEmail: string[] = [];

  constructor() {
    super();

    this.id = localIdPrefix + getLocalId();
  }

  get isLocal() {
    return isRegionLocalId(this.id);
  }

  public fromJSON(json: Partial<RegionJSON>) {
    if (isRegionLocalId(json.id)) {
      this.id = json.id;
    } else {
      this.id = Number(json.id);
    }

    if (json.code) {
      this.code = String(json.code);
      this.name = this.code;
    }

    if (json.name) {
      this.name = String(json.name);
    }

    if (json.status === 0 || (json.status as unknown as string) === '0') {
      this.status = 0;
    }

    if (json.admin_email && Array.isArray(json.admin_email)) {
      this.adminEmail = json.admin_email;
    }
  }
}
